import React from "react";
import { makeStyles } from "@mui/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import PropTypes from "prop-types";
import { pascalEnumToString } from "../../util/jbhTextFormatterUtil";
import { TextField } from "@mui/material";

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(0),
		minWidth: 120,
		width: "100%",
	},
	select: {
		fontSize: "large",
		marginTop: 10,
		backgroundColor: "white",
	},
}));

export default function CommercialSelect(props) {
	const { menuItems, onChange, currentValue } = props;
	const classes = useStyles();
	const handleChange = (event) => {
		onChange(event.target.value);
	};

	return (
		<FormControl className={classes.formControl}>
			<TextField
				id="commercial-select"
				value={currentValue ?? ""}
				onChange={handleChange}
				className={classes.select}
				select
				label="Select A Commercial Account"
				variant="outlined"
				slotProps={{
					inputLabel: { shrink: Boolean(currentValue) }
				}}
			>
				{menuItems.map((item) => (
					<MenuItem key={item.value} value={item.value}>
						{pascalEnumToString(item.label)}
					</MenuItem>
				))}
			</TextField>
		</FormControl>
	);
}

CommercialSelect.propTypes = {
	id: PropTypes.string,
	menuItems: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	currentValue: PropTypes.string,
};
